import { render, staticRenderFns } from "./EnfermeraView.vue?vue&type=template&id=8fd4d014"
import script from "./EnfermeraView.vue?vue&type=script&lang=js"
export * from "./EnfermeraView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports